import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, Option, FormLabel, Box } from '@mui/joy';
import { PAYMENT_METHOD_OPTIONS, PAYMENT_METHOD_OPTIONS_WITH_ALL } from '../constants/paymentMethods';

export default function PaymentMethodOptionList({
    label,
    required,
    currentPaymentMethod,
    setCurrentPaymentMethod,
    showAll = false,
    disabled = false,
    placeholder,
}) {
    const { t } = useTranslation('ui');
    const resolvedLabel = label ?? t('widgets.paymentMethod');
    const resolvedPlaceholder = placeholder ?? t('widgets.selectPaymentMethod');
    const options = showAll ? PAYMENT_METHOD_OPTIONS_WITH_ALL : PAYMENT_METHOD_OPTIONS;
    return (
        <Box sx={{ marginBottom: 2 }}>
            <FormLabel
                sx={{
                    fontWeight: 600,
                    color: '#555',
                    marginBottom: '6px',
                    fontSize: '14px',
                }}
            >
                {required ? `${resolvedLabel} *` : resolvedLabel}
            </FormLabel>
            <Select
                value={currentPaymentMethod}
                onChange={(e, newValue) => setCurrentPaymentMethod(newValue)}
                required={required}
                disabled={disabled}
                placeholder={resolvedPlaceholder}
                sx={{
                    backgroundColor: '#f7f9fc',
                    borderRadius: '8px',
                    padding: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                        borderColor: '#5f09c2',
                    },
                    '&:focus': {
                        borderColor: '#5f09c2',
                        outline: 'none',
                        boxShadow: '0 0 6px rgba(0, 123, 255, 0.5)',
                    },
                    '&[disabled]': {
                        backgroundColor: '#e9ecef',
                        color: '#6c757d',
                        cursor: 'not-allowed',
                    },
                }}
            >
                {options.map((opt) => (
                    <Option key={opt.value || 'all'} value={opt.value}>{opt.label}</Option>
                ))}
            </Select>
        </Box>
    );
}